import sendLocalRequest from "./sendLocalRequest";
import {UI_CONFIG} from "../../config";

export const getMachinesWithActiveErrors = (auth_token, error_mask1_flags, from_exclusive_start_key, count) => {
    return  new Promise( (resolve, reject) => {
        // if (!error_mask1_flags) {
        //     error_mask1_flags = "";
        // }
        const body = {
            error_mask1_flags: error_mask1_flags,
            count: UI_CONFIG.MACHINES_WITH_ERROR_PER_PAGE
        }

        let url = "machines/machines_with_active_errors"
        if (count !== null && count !== undefined) {
            // url += `&count=${count}`;
            body["count"] = count;
        }
        if (from_exclusive_start_key !== null && from_exclusive_start_key !== undefined) {
            // url += `&from_exclusive_start_key=${from_exclusive_start_key}`;
            body["from_exclusive_start_key"] = from_exclusive_start_key
        }


        sendLocalRequest(url, "POST", auth_token, body).then( (result) => {
            resolve(result);
        }).catch( (error) => {
            reject(error);
        })
    });



};
